<div class="color-palette-preview" [class]="'size-' + size" [class.mode-compact]="displayMode === 'compact'" [class.mode-detailed]="displayMode === 'detailed'">
	<!-- Show palette name at the top if enabled -->
	@if (showName && palette) {
		<div class="palette-name mb-2">{{ palette.name }}</div>
	}

	<!-- Detailed Mode: Vertical layout -->
	@if (displayMode === 'detailed') {
		<div class="themes-container single-theme">
			<div class="theme-preview">
				<div class="color-strip">
					@for (colorData of getColors(); track colorData.label) {
						<div
							class="color-sample"
							[style.background-color]="colorData.color"
							[title]="colorData.label + ': ' + colorData.color"
						>
							@if (showColorLabels) {
								<span class="color-label">{{ colorData.label }}</span>
							}
						</div>
					}
				</div>
			</div>
		</div>
	}

	<!-- Compact Mode: Horizontal single line of swatches -->
	@if (displayMode === 'compact') {
		<div class="compact-container">
			<div class="compact-column">
				@for (colorData of getColors(); track colorData.label) {
					<div
						class="color-swatch-compact"
						[style.background-color]="colorData.color"
						[title]="colorData.label + ': ' + colorData.color"
					></div>
				}
			</div>
		</div>
	}
</div>
